// extracted by mini-css-extract-plugin
export default {"options":"styles_options__D5BEl","box":"styles_box__6fCdR","hide":"styles_hide__93CBe","reverse":"styles_reverse__Pbe6S"};